import { TemplateDto } from "../models/templates";
import { Client, mapUrl } from "../client";
import { Controller, Endpoint } from "..";

export const fetchFilledMessagingTemplateById = (
	id: string,
	messageId: string
): Promise<TemplateDto> => {
	return Client.instance.get<TemplateDto>(mapUrl(Controller.MessagingTemplates,  id, Endpoint.Filled), {
		messageSessionId: messageId,
	});
};

export const fetchFilledVoiceTemplateById = (
	id: string,
	interactionId: string,
	contactName: string
): Promise<string> => {
	return Client.instance.get<string>(mapUrl(Controller.VoiceTemplates, id, Endpoint.Filled), {
		callSessionId: interactionId,
		contactName: contactName,
	});
};

